<!-- basic template for most components -->
<template>
	<div>
	  <page-heading-info
    title="Jefferson County COVID-19 (Coronavirus) Information"
    courthouse="true"
    ></page-heading-info>

		<div style="padding-left: 15px; padding-right: 15px;">
		<div class="row mt-3">
      <div class="col-md-8">
        <note-text note-id="31" class="text-box-p"></note-text>
      </div>
  </div>
  </div>
	</div>
</template>

<script>
import PageHeadingInfo from '@/components/layout/PageHeadingInfo.vue'
import TextBoxTitle from '@/components/layout/TextBoxTitle.vue'
import NoteText from '@/components/display-utils/NoteText.vue'

export default {
	components: {
		PageHeadingInfo,
    TextBoxTitle,
    NoteText
	},
  data () {
    return {}
  },
  props: [],
  mounted: function() {
    //called on launch
  },
  methods: {}
}

</script>

<style>
</style>
